import * as React from 'react';
import { bindActionCreators } from 'redux';
import { RouterState, withRouter } from 'react-router';
import { Query } from 'history';
import * as termsOfServiceActions from 'login-actions/termsOfServiceActions';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import FormDialog from 'login-components/Common/Form/FormDialog/FormDialog';
import AppDocumentTitle from 'login-components/Common/AppDocumentTitle/AppDocumentTitle';
import AppFooterUpdater from 'login-components/Common/AppFooterUpdater';
import TermsOfServiceViewer from './TermsOfServiceViewer/TermsOfServiceViewer';
import AppTitleUpdater from 'login-components/Common/AppTitleUpdater';
import './TermsOfService.scss';
import * as stateUtils from 'login-utils/stateUtils';

interface TermsOfServiceOwnProps {
  onSubmit?: (event: React.FormEvent<any>) => void;
  isSubmitting?: boolean;
  action?: string;
  queryParams?: {
    loanType?: string;
    applicationTemplateId?: string;
    displayLink?: string;
    referrerId?: string;
    app_source?: string;
  };
  title?: string;
  showAgreeText?: boolean;
}

export interface TermsOfServiceProps extends TextScreenState, RouterState, TermsOfServiceOwnProps {}

interface DispatchProps {
  getTermsText: typeof termsOfServiceActions.getTermsText;
}

// test only export
export function getTOSError(query: Query) {
  const errorMessage = stateUtils.getMessageQueryParam(query);
  switch (errorMessage) {
    case 'acceptTOSError':
      return 'An error occurred while accepting Terms of Use. Please try again or reach out to your banker or loan officer for assistance.';
    case 'activationKeyError':
      return 'The activation link is expired or invalid. Please reach out to your banker or loan officer for a new activation link.';
    case 'alreadyActivated':
      return 'The activation link has already been used. Please reach out to your banker or loan officer for a new activation link.';
    default:
      return undefined;
  }
}

class TermsOfService extends React.Component<TermsOfServiceProps & DispatchProps, object> {
  componentDidMount() {
    const { getTermsText } = this.props;
    return getTermsText();
  }

  render() {
    const { showAgreeText = true, content, location, onSubmit, queryParams, title, isSubmitting, action } = this.props;
    // There will be a render pass where nothing is available; that's fine.
    const htmlText = content;
    const tosError = getTOSError(queryString.parse(location.search));

    return (
      <div className="TermsOfService">
        <AppDocumentTitle title={title || 'Accept Terms of Use'}>
          <AppTitleUpdater text={null as any}>
            <AppFooterUpdater footerConfig={null}>
              <FormDialog>
                <TermsOfServiceViewer
                  onSubmit={onSubmit}
                  queryParams={queryParams}
                  disableSubmit={isSubmitting}
                  error={tosError}
                  htmlText={htmlText}
                  action={action || '/api/users/self/accept-terms'}
                  showAgreeText={showAgreeText}
                />
              </FormDialog>
            </AppFooterUpdater>
          </AppTitleUpdater>
        </AppDocumentTitle>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getTermsText: termsOfServiceActions.getTermsText }, dispatch);
};

const mapStateToProps = state => ({
  ...state.terms,
});

const ConnectedTermsOfService = withRouter<React.ComponentClass<TermsOfServiceOwnProps>>(connect(
  mapStateToProps,
  mapDispatchToProps,
)(TermsOfService) as any);

export default ConnectedTermsOfService;
